<template>
  <div style="position: relative;display: flex;justify-content: flex-start">
    <template v-if="alwaysShow || currentState!==states.hidePop">
      <div>
        <span> {{ lbSize.text }}</span>
      </div>

      <div v-for="(item,index) in exchangeAmount.dataProvider" :key="index">
        <charge-count-item-renderer :item="item" />
      </div>
    </template>

    <span v-show="showDetail" style="color:deepskyblue;cursor:pointer;padding-left: 5px;" @click="chargeCountGroupHP.clickHandler($event)"> {{ $t('CargoMsg.Cargo_AmountToDetail') }} <i :class="currentState===states.hidePop?'el-icon-caret-bottom':'el-icon-caret-top'" /> </span>

    <cargo-ag-grid
      v-show="showDetail && currentState===states.dispPop"
      :show-side-bar="false"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      :style="detailGridStyle"
    />
  </div>
</template>

<script>
import ChargeCountGroupHP from './ChargeCountGroupHP'

import ChargeCountItemRenderer from './ChargeCountItemRenderer'
const hidePop = 'hidePop'
const dispPop = 'dispPop'
const states = { hidePop, dispPop }
export default {
  name: 'ChargeCountGroup',
  components: { ChargeCountItemRenderer },
  props: {
    basicCurrency: { type: String, default: 'RMB' }, // 折合总计的币种
    displayAndCountFieldList: { type: Array, default: () => [] }, // 需要统计和显示的字段
    dataProvider: { type: Array, default: () => { return [] } }, // 需要统计的数据源
    newCurrencyCode: { type: Boolean, default: false }, // 使用币种合计
    showRmb: { type: Boolean, default: false }, // 展示折合RMB
    newByJob: { type: Number, default: 0 }, // 用于财务审核 和 付款申请 1 // 1 付款申请 业务; 2 付款申请 费用; 3 财务审核; 4:未销账列表-按发票查询
    alwaysShow: { type: Boolean, default: true },
    showDetail: { type: Boolean, default: true },
    selectedCount: { type: Number, default: 0 },
    source: { type: String, default: '' },
    dataField: { type: String, default: 'charge_amount' },
    chargeTotalData: { type: Array, default: () => [] }
  },
  data() {
    return {
      states,
      lbSize: {
        text: ''
      },
      currentState: states.hidePop,
      chargeCountGroupHP: new ChargeCountGroupHP(this),
      exchangeAmount: { dataProvider: [] }, // 折合金额
      gridOptions: {

      },
      rowData: [],
      columnDefs: [],
      chargeCountGridResultList: [], // 已经统计好的结果(用以表格显示
      closedState: 0 // //详情窗体是否被用户手动打开或关闭 0 初始状态 1 手动打开状态 2 手动关闭状态
    }
  },
  computed: {
    detailGridStyle() {
      const columnWidth = this.columnDefs.reduce((total, column) => total + (Number(column.width) || 100), 0)
      const width = Math.max(300, columnWidth + 20)
      return {
        width: `${width}px`,
        maxWidth: 'calc(100vw - 30px)',
        height: '200px',
        position: 'absolute',
        bottom: '50px',
        right: '0'
      }
    }
  },
  watch: {
    dataProvider(val) {
      console.log('countGroup watch dataProvider ')
      this.chargeCountGroupHP.groupingCalc()
    },
    chargeTotalData(val) {
      this.chargeCountGroupHP.groupingCalc()
    }

  },
  created() {
    this.chargeCountGroupHP.commitProperties()
  },
  methods: {
    toggle() {
      this.currentState = this.currentState === this.states.hidePop ? this.states.dispPop : this.states.hidePop
    }
  }
}
</script>

<style scoped>

</style>
